import {
  Box,
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@material-ui/core";
import {
  Delete,
  Edit,
  MoreVert,
  OpenInNew,
  WarningOutlined,
} from "@material-ui/icons";
import { LuPencil, LuSearch, LuShare2 } from "react-icons/lu";
import { menuItemStyle, menuListProps, menuPaperProps } from "../../../../common/menuStyles";
import SaveIcon from "@material-ui/icons/Save";
import ShareIcon from "@material-ui/icons/Share";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { TabContext, TabPanel } from "@material-ui/lab";
import _ from "lodash";
import moment from "moment";
import { useCallback, useEffect, useRef, useState } from "react";
import { LuArrowDown, LuArrowDownUp, LuArrowUp } from "react-icons/lu";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { v4 as uuidv4 } from "uuid";
import SearchBar from "../../../../common/Search";
import CustomTabs from "../../../../common/Tabs";
import Tooltip from "../../../../common/Tooltip";
import VesselContractForm from "../../../../components/Calculator/AddCalculatorFleet/createVesselContractModel";
import SaveCargoLabel from "../../../../components/Calculator/SaveCargoLabel";
import CustomAddModal from "../../../../components/Common/CustomAddModal";
import CustomConfirmModal from "../../../../components/Common/CustomConfirmModal";
import CustomPagination from "../../../../components/Common/CustomPagination";
import CustomShowModal from "../../../../components/Common/CustomShowModal";
import {
  getCurrentUserId,
  getOrganizationId,
  toastError,
  toastSuccess,
} from "../../../../utils";
import { createVesselContract } from "../../Fleet/action";
import { createCargoContract } from "../../Orders/actions";
import CreateCargoAnalysis from "../../Orders/CreateCargoAnalysis";
import CreateCargoContractForm from "../../Orders/createCargoContractModel";
import {
  createEstimateContract,
  deleteCargoContract,
  deleteEstimateContract,
  deleteVesselContract,
  getAllCargoContract,
  getAllEstimateContract,
  getAllVesselContract,
  getCargoContractById,
  getEstimateContractById,
  getGeneralMasterData,
  getVesselContractById,
  updateCargoContract,
  updateVesselContract,
} from "../actions";
import CargoViewModel from "./CargoViewModel";
import ContractSelectionStepper from "./contractSelectionStepper";
import EstimateCreateConfirmationModal from "./EstimateCreateConfirmationModal";
import ShareToOperationModel from "./ShareToOperationModel";
import VesselViewModel from "./VesselViewModel";


const initialPagination = {
  offset: 1,
  limit: 50,
  totalPages: 0,
  totalItems: 0,
  search: "",
  startDate: "",
  endDate: "",
  sortBy: "createdAt",
  sortDirection: "desc",
};

export const initialContractFields = {
  cargoFixtureId: "",
  contractName: "",
  cpDate: moment().format('YYYY-MM-DD'),
  counterpartyFullStyle: "",
  bankingDetails: "",
  contractingCompany: "",
  department: "",
  tradeArea: "",
  vesselType: "",
  minQty: "",
  maxQty: "",
  freightRate: "",
  currency: "",
  shipmentNo: "",
  charteringPIC: "",
  opsCoordinator: "",
  comments: "",
  loadingPortDemurrage: "",
  loadingPortDespatch: "",
  dischargingPortDemurrage: "",
  dischargingPortDespatch: "",
  cargoDetails: {},
  cargoList: [],
  counterPartyNames: [
    {
      name: "",
      type: "",
    },
  ],
  brokers: [
    {
      name: "",
      type: "",
    },
  ],
};

export const initialVesselContractFields = {
  contractName: "",
  vesselId: "",
  vesselFixtureId: "",
  cpDate: moment().format('YYYY-MM-DD'),
  counterParty: "",
  bankingDetails: "",
  contractingCompany: "",
  department: "",
  tradeArea: "",
  vesselType: "",
  currency: "",
  shipmentNo: "",
  charteringPIC: "",
  opsCoordinator: "",
  comments: "",
  vesselDetails: {},
  vesselOutContract: {
    vesselDetails: {}
  }
};

const mergeVesselContractData = (fullData) => {
  if (!fullData || typeof fullData !== "object") return {};

  const actualVC =
    fullData.actualVesselContract &&
    typeof fullData.actualVesselContract === "object"
      ? fullData.actualVesselContract
      : {};
  const vesselDet =
    fullData.vesselDetails && typeof fullData.vesselDetails === "object"
      ? fullData.vesselDetails
      : {};
  const vesselDat =
    fullData.vesselData && typeof fullData.vesselData === "object"
      ? fullData.vesselData
      : {};

  const sources = [fullData, vesselDat, vesselDet, actualVC];
  const merged = {};

  sources.forEach((source) => {
    if (!source || typeof source !== "object") return;
    Object.keys(source).forEach((key) => {
      if (
        key === "actualVesselContract" ||
        key === "vesselOutContract" ||
        key === "operationVesselContract"
      )
        return;
      const val = source[key];
      if (Array.isArray(val)) {
        if (val.length > 0 || !merged[key]) {
          merged[key] = val;
        }
      } else if (val !== undefined && val !== null && val !== "") {
        merged[key] = val;
      } else if (merged[key] === undefined) {
        merged[key] = val;
      }
    });
  });

  merged._id = fullData._id || actualVC._id || merged._id;
  merged.actualVesselContract = fullData.actualVesselContract;
  merged.vesselOutContract = fullData.vesselOutContract;
  merged.operationVesselContract = fullData.operationVesselContract;
  return merged;
};


const Contracts = (props) => {
  const { loader = false, setLoader = () => { } } = props;
  const isInitialRender = useRef(true);
  const searchParams = useLocation();
  const history = useHistory();
  const [mainTab, setMainTab] = useState(0);
  const access = mainTab === 0 ? "private" : "public";
  const [subTab, setSubTab] = useState("1");
  const addQueryModalRef = useRef();
  const vesselRef = useRef(null);
  // Request ID refs to prevent stale concurrent fetch races
  const cargoFetchId = useRef(0);
  const vesselFetchId = useRef(0);
  const estimateFetchId = useRef(0);

  const [vesselContractDetails, setVesselContractDetails] = useState([]);
  const [cargoContractDetails, setCargoContractDetails] = useState([]);
  const [hasFetchedCargo, setHasFetchedCargo] = useState(false);
  const [hasFetchedVessel, setHasFetchedVessel] = useState(false);
  const [hasFetchedEstimate, setHasFetchedEstimate] = useState(false);
  const activeRequests = useRef(0);

  const handleSetLoader = (isLoading, msg) => {
    if (isLoading) {
      activeRequests.current += 1;
      setLoader(true, msg);
    } else {
      activeRequests.current = Math.max(0, activeRequests.current - 1);
      if (activeRequests.current === 0) {
        setLoader(false);
      }
    }
  };

  const [isLoadingCargo, setIsLoadingCargo] = useState(true);
  const [isLoadingVessel, setIsLoadingVessel] = useState(true);
  const [isLoadingEstimate, setIsLoadingEstimate] = useState(true);
  const [estimateContractDetails, setEstimateContractDetails] = useState([]);
  const [selectedCargo, setSelectedCargo] = useState(null);
  const [selectedVessel, setSelectedVessel] = useState(null);
  const [cargoAnalysisStepper, setCargoAnalysisStepper] = useState();
  const [selectedPorts, setSelectedPorts] = useState();
  const [cargoAnalysisData, setCargoAnalysisData] = useState();
  const [analysisVessel, setAnalysisVessel] = useState();
  const organizationId = getOrganizationId();
  const currentUserId = getCurrentUserId();
  const userId = getCurrentUserId();
  const [modelOpen, setModelOpen] = useState(false);
  const [estimateShareModelOpen, setEstimateShareModelOpen] = useState(false);
  const [vesselShareModelOpen, setVesselShareModelOpen] = useState(false);
  const [cargoShareModelOpen, setCargoShareModelOpen] = useState(false);
  const [modelType, setModelType] = useState(""); // 'cargo' or 'vessel'
  const [currentContract, setCurrentContract] = useState(null);


  useEffect(() => {
    const queryParams = new URLSearchParams(searchParams.search);
    const tab = queryParams.get("tab");
    if (tab) {
      if (tab !== subTab) {
        setSubTab(tab);
      }
    } else {
      history.replace({
        search: `?tab=${subTab}`,
      });
    }
  }, [searchParams.search]);


  const [selectedContractForShare, setSelectedContractForShare] = useState({
    _id: "",
    data: {},
  });
  const [menuContractId, setMenuContractId] = useState(null);
  const handleMenuOpen = (event, contract, subItem) => {
    setAnchorEl(event.currentTarget);
    setMenuContractId(contract._id);
    setSelectedItem({ item: contract, subItem });
  };

  const handleUpdateVesselDetails = () => {
    vesselRef.current?.submit();
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedItem({ item: null, subItem: null });
    setMenuContractId(null);
  };
  const [isVesselViewModelOpen, setIsVesselViewModelOpen] = useState(false);
  const [isCargoViewModelOpen, setIsCargoViewModelOpen] = useState(false);
  const [estimateCreateConfirmationOpen, setEstimateCreateConfirmationOpen] =
    useState(false);
  const [estimateData, setEstimateData] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState({
    item: null,
    subItem: null,
  });
  const [isShareToOperationModelOpen, setIsShareToOperationModelOpen] =
    useState(false);
  const open = Boolean(anchorEl);

  const handleEstimateCreation = (data) => {
    setEstimateData(data);
    setEstimateCreateConfirmationOpen(true);
  };

  const confirmEstimateCreation = () => {
    onSubmitConfirm(estimateData);
    setEstimateCreateConfirmationOpen(false);
  };

  const closeEstimateModal = () => {
    setEstimateCreateConfirmationOpen(false);
  };

  const [
    cargoDeleteComformationModelOpen,
    setCargoDeleteComformationModelOpen,
  ] = useState(false);
  const [selectedCargoForDelete, setSelectedCargoForDelete] = useState("");

  const [
    vesselDeleteComformationModelOpen,
    setVesselDeleteComformationModelOpen,
  ] = useState(false);
  const [selectedVesselForDelete, setSelectedVesselForDelete] = useState("");

  const [
    estimateDeleteComformationModelOpen,
    setEstimateDeleteComformationModelOpen,
  ] = useState(false);
  const [selectedEstimateForDelete, setSelectedEstimateForDelete] =
    useState("");

  const [isCargoEditing, setIsCargoEditing] = useState(false);
  const [cargoFormData, setCargoFormData] = useState(initialContractFields);
  const [cargoTextContract, setCargoTextContract] = useState(null);
  const [prevAttachments, setPrevAttachments] = useState({
    attachments: [],
    textContract: "",
  });
  const [cargoAttachments, setCargoAttachments] = useState([]);
  const [copyWarningModal, setIsCopyWarningModalOpen] = useState({
    isOpen: false,
    type: "",
  });
  const [updateWarningModal, setIsUpdateWarningModalOpen] = useState({
    isOpen: false,
    type: "",
  });
  const [showClosedContract, setShowClosedContract] = useState({
    isOpen: false,
    id: "",
  });
  const [isVesselEditing, setIsVesselEditing] = useState(false);
  const [vesselFormData, setVesselFormData] = useState(
    initialVesselContractFields
  );
  const [vesselTextContract, setVesselTextContract] = useState(null);
  const [vesselAttachments, setVesselAttachments] = useState([]);

  // Separate pagination states for vessel and cargo
  const [vesselFilters, setVesselFilters] = useState(initialPagination);
  const [cargoFilters, setCargoFilters] = useState(initialPagination);
  const [estimateFilters, setEstimateFilters] = useState(initialPagination);

  // Modal specific pagination states
  const [modalVesselFilters, setModalVesselFilters] =
    useState(initialPagination);
  const [modalCargoFilters, setModalCargoFilters] = useState(initialPagination);

  const handleMainTabChange = (event, newValue) => {
    setMainTab(newValue);
  };

  const handleSubTabChange = (event, newValue) => {
    setSubTab(newValue);
    history.push({
      search: `?tab=${newValue}`
    });
  };

  const fetchCargoContracts = async (filters = cargoFilters, showLoader = true) => {
    const fetchId = ++cargoFetchId.current;
    if (showLoader) setIsLoadingCargo(true);
    try {
      const { offset, limit, search, startDate, endDate, sortBy, sortDirection } = filters;
      const targetId = access === "public" ? organizationId : currentUserId;
      const cargoRes = await getAllCargoContract(
        { organizationId: targetId },
        {
          page: offset,
          limit,
          access,
          ...(search && { search }),
          ...(startDate && { startDate }),
          ...(endDate && { endDate }),
          ...(sortBy && { sortBy }),
          ...(sortDirection && { sortDirection }),
        }
      );
      if (fetchId !== cargoFetchId.current) return; // stale — a newer request is in flight
      setCargoContractDetails(cargoRes.data || []);
      if (cargoRes) {
        setCargoFilters((prev) => ({
          ...prev,
          totalItems: cargoRes.totalItems || 0,
          totalPages: cargoRes.totalPages || 0,
        }));
      }
    } catch (err) {
      if (fetchId !== cargoFetchId.current) return;
      console.error(err);
      setCargoContractDetails([]);
      return null;
    } finally {
      if (fetchId === cargoFetchId.current) {
        if (showLoader) setIsLoadingCargo(false);
        setHasFetchedCargo(true);
      }
    }
  };

  const fetchVesselContracts = async (filters = vesselFilters, showLoader = true) => {
    const fetchId = ++vesselFetchId.current;
    if (showLoader) setIsLoadingVessel(true);
    try {
      const { offset, limit, search, startDate, endDate, sortBy, sortDirection } = filters;
      const targetId = access === "public" ? organizationId : currentUserId;
      const vesselRes = await getAllVesselContract(
        { organizationId: targetId },
        {
          page: offset,
          limit,
          access,
          ...(search && { search }),
          ...(startDate && { startDate }),
          ...(endDate && { endDate }),
          ...(sortBy && { sortBy }),
          ...(sortDirection && { sortDirection }),
        }
      );
      if (fetchId !== vesselFetchId.current) return;
      setVesselContractDetails(vesselRes.data || []);
      if (vesselRes) {
        setVesselFilters((prev) => ({
          ...prev,
          totalItems: vesselRes.totalItems || 0,
          totalPages: vesselRes.totalPages || 0,
        }));
      }
    } catch (err) {
      if (fetchId !== vesselFetchId.current) return;
      console.error(err);
      setVesselContractDetails([]);
      return null;
    } finally {
      if (fetchId === vesselFetchId.current) {
        if (showLoader) setIsLoadingVessel(false);
        setHasFetchedVessel(true);
      }
    }
  };

  const fetchEstimateContracts = async (filters = estimateFilters, showLoader = true) => {
    const fetchId = ++estimateFetchId.current;
    if (showLoader) setIsLoadingEstimate(true);
    try {
      const { offset, limit, search, startDate, endDate, sortBy, sortDirection } = filters;
      const targetId = access === "public" ? organizationId : currentUserId;
      const estimateRes = await getAllEstimateContract(
        { organizationId: targetId },
        {
          page: offset,
          limit,
          access,
          ...(search && { search }),
          ...(startDate && { startDate }),
          ...(endDate && { endDate }),
          ...(sortBy && { sortBy }),
          ...(sortDirection && { sortDirection }),
        }
      );
      if (fetchId !== estimateFetchId.current) return;
      setEstimateContractDetails(estimateRes.data || []);
      if (estimateRes) {
        setEstimateFilters((prev) => ({
          ...prev,
          totalItems: estimateRes.totalItems || 0,
          totalPages: estimateRes.totalPages || 0,
        }));
      }
    } catch (err) {
      if (fetchId !== estimateFetchId.current) return;
      console.error(err);
      setEstimateContractDetails([]);
      return null;
    } finally {
      if (fetchId === estimateFetchId.current) {
        if (showLoader) setIsLoadingEstimate(false);
        setHasFetchedEstimate(true);
      }
    }
  };

  const handlePagination = (type) => {
    const isVessel = subTab === "2";
    const isCargo = subTab === "1";
    const setFilters = isVessel
      ? setVesselFilters
      : isCargo
        ? setCargoFilters
        : setEstimateFilters;

    setFilters((prev) => {
      const currentPage = prev.offset || 1;
      let newPage = currentPage;

      if (type === "first") {
        newPage = 1;
      } else if (type === "dec" && currentPage > 1) {
        newPage = currentPage - 1;
      } else if (type === "inc" && currentPage < prev.totalPages) {
        newPage = currentPage + 1;
      } else if (type === "last") {
        newPage = prev.totalPages;
      }

      return {
        ...prev,
        offset: newPage,
      };
    });
  };

  // Modal pagination handler
  const handleModalPagination = (action) => {
    const isVesselModal = modelType === "vessel";
    const filters = isVesselModal ? modalVesselFilters : modalCargoFilters;
    const setFilters = isVesselModal
      ? setModalVesselFilters
      : setModalCargoFilters;

    let newPage = filters.offset;

    if (action === "first") {
      newPage = 1;
    } else if (action === "dec") {
      if (filters.offset > 1) {
        newPage = filters.offset - 1;
      }
    } else if (action === "inc") {
      if (filters.offset < filters?.totalPages) {
        newPage = filters.offset + 1;
      }
    } else if (action === "last") {
      newPage = filters?.totalPages;
    }

    if (newPage !== filters.offset) {
      setFilters((prev) => ({
        ...prev,
        offset: newPage,
      }));
    }
  };

  // Load modal data based on the type
  useEffect(() => {
    if (!modelOpen) return;

    const loadModalData = async () => {
      if (modelType === "vessel") {
        const { offset, limit } = modalVesselFilters;
        const vesselRes = await fetchVesselContracts(
          { page: offset, limit },
          (data) => {
            setVesselContractDetails(data);
          }
        );

        if (vesselRes) {
          setModalVesselFilters((prev) => ({
            ...prev,
            totalItems: vesselRes.totalItems || 0,
            totalPages: vesselRes?.totalPages || 0,
          }));
        }
      } else {
        const { offset, limit } = modalCargoFilters;
        const cargoRes = await fetchCargoContracts(
          { page: offset, limit },
          (data) => {
            setCargoContractDetails(data);
          }
        );

        if (cargoRes) {
          setModalCargoFilters((prev) => ({
            ...prev,
            totalItems: cargoRes.totalItems || 0,
            totalPages: cargoRes?.totalPages || 0,
          }));
        }
      }
    };

    loadModalData();
  }, [
    modelOpen,
    modelType,
    modalVesselFilters.offset,
    modalCargoFilters.offset,
  ]);

  const onClickSaveCargoVesselEstimate = (id, data) => {
    setCurrentContract(data);

    if (subTab === "1" && data.contractType === "cargo-cargo") {
      setModelType("vessel");
      setSelectedVessel(null);
      setModalVesselFilters(initialPagination);
    } else if (subTab === "2" && data.contractType === "vessel-vessel") {
      setModelType("cargo");
      setSelectedCargo(null);
      setModalCargoFilters(initialPagination);
    } else if (data?.contractType === "vessel-cargo") {
      setModelType("vessel-cargo");
      subTab === "1" ? setSelectedVessel(null) : setSelectedCargo(null);
      subTab === "1"
        ? setModalVesselFilters(initialPagination)
        : setModalCargoFilters(initialPagination);
    } else if (!data?.contractType) {
      setModelType("general");
    }
    setModelOpen(true);
  };

  const onClickVessel = (vessel) => {
    setSelectedVessel(vessel);
  };

  const onClickCargo = (cargo) => {
    setSelectedCargo(cargo);
  };

  const onCloseSaveCargoVesselModal = () => {
    setModelOpen(false);
    setCurrentContract(null);
    setSelectedVessel(null);
    setSelectedCargo(null);
    setEstimateCreateConfirmationOpen(false);
  };

  const onSubmitConfirm = async (data) => {
    try {
      const { vendorCargo, vesselData, ...restData } = data;
      await createEstimateContract({
        ...(restData.contractType === "cargo-cargo" ? restData : data),
        organizationId,
      });

      if (data?.contractType === "cargo-cargo") {
        await updateCargoContract(
          { _id: data?.cargoContractId },
          {
            status: "close",
            contractType: data?.contractType,
            vesselData,
            vendorCargo,
          }
        );
        await fetchCargoContracts();
      } else if (data?.contractType === "vessel-cargo") {
        await updateCargoContract(
          { _id: data?.cargoContractId },
          { status: "close", contractType: data?.contractType }
        );
        await updateVesselContract(
          { _id: data?.vesselContractId },
          { status: "close", contractType: data?.contractType }
        );
        await fetchVesselContracts();
        await fetchCargoContracts();
      } else if (data?.contractType === "vessel-vessel") {
        await updateVesselContract(
          { _id: data?.vesselContractId },
          { status: "close", contractType: data?.contractType }
        );
        await fetchVesselContracts();
      }

      onCloseSaveCargoVesselModal();
      toastSuccess("Estimate Contract Created Successfully");
      setSubTab("3");
      history.push({
        search: `?tab=3`
      });
      await fetchEstimateContracts();
    } catch (err) {
      console.error("Error Creating Estimate Contract", err);
      toastError(err.message || "Failed to create estimate contract");
    }
  };
  const handleContractEdit = async (data) => {
    handleSetLoader(true);
    try {
      const targetId = data?._id || data?.contractId || data?.cargoId || data?.vesselId || data?.id;
      if (subTab === "1") {
        const fullDataRes = await getCargoContractById(targetId);
        const fullData = fullDataRes.data || fullDataRes;
        const customerCargoObj =
          fullData?.cargoDetails?.customerCargo ||
          fullData?.cargoDetails ||
          fullData?.customerCargo ||
          fullData;

        const cargoList =
          customerCargoObj?.cargoList || fullData?.cargoList || [];

        setIsCargoEditing(true);
        setCargoFormData({
          ...fullData,
          ...customerCargoObj,
          _id: targetId,
          cargoList: cargoList,
        });
        setPrevAttachments({
          attachments: [...(fullData?.attachments || [])],
          textContract: fullData?.textContract,
        });
      } else if (subTab === "2") {
        const fullDataRes = await getVesselContractById(targetId);
        const fullData = fullDataRes.data || fullDataRes;
        const vesselFormDataObj = mergeVesselContractData(fullData);

        setIsVesselEditing(true);
        setVesselFormData(vesselFormDataObj);
        setPrevAttachments({
          attachments: [...(vesselFormDataObj?.attachments || [])],
          textContract: vesselFormDataObj?.textContract || "",
        });
      }
    } catch (err) {
      toastError("Failed to fetch full contract details");
    } finally {
      handleSetLoader(false);
    }
  };

  const handleCloseEditModel = () => {
    if (subTab === "1") {
      setIsCargoEditing(false);
      setCargoFormData(initialContractFields);
    } else if (subTab === "2") {
      setIsVesselEditing(false);
      setVesselFormData(initialVesselContractFields);
    }
  };

  const handleCargoContractInputChange = (e) => {
    const { name, value } = e.target;
    setCargoFormData({
      ...cargoFormData,
      [name]: value,
    });
  };

  const handleVesselContractInputChange = (e) => {
    const { name, value } = e.target;
    setVesselFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCargoTextContractUpload = (e) => {
    if (e.target.files[0]) {
      setCargoTextContract(e.target.files[0]);
    }
  };

  const handleCargoContractAttachmentUpload = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      const validFiles = newFiles.filter(
        (file) => file.size <= 5 * 1024 * 1024
      );

      if (validFiles.length !== newFiles.length) {
        alert("Some files exceed the 5 MB size limit and were not added.");
      }

      setCargoAttachments((prev) => [...(Array.isArray(prev) ? prev : []), ...validFiles]);
    }
  };

  const removeCargoAttachment = (index) => {
    setCargoAttachments((prev) => (Array.isArray(prev) ? prev : []).filter((_, i) => i !== index));
  };

  const handleVesselTextContractUpload = (e) => {
    if (e.target.files[0]) {
      setVesselTextContract(e.target.files[0]);
    }
  };

  const handleVesselContractAttachmentUpload = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      const validFiles = newFiles.filter(
        (file) => file.size <= 5 * 1024 * 1024
      );

      if (validFiles.length !== newFiles.length) {
        alert("Some files exceed the 5 MB size limit and were not added.");
      }

      setVesselAttachments((prev) => [...(Array.isArray(prev) ? prev : []), ...validFiles]);
    }
  };

  const removeVesselAttachment = (index) => {
    setVesselAttachments((prev) => (Array.isArray(prev) ? prev : []).filter((_, i) => i !== index));
  };

  const handleUpdateWarningModal = (type) => {
    setIsUpdateWarningModalOpen({
      isOpen: true,
      type,
    });
  };

  const handleUpdateCargoContract = () => {
    const { _id, cargoList, actualCargoContract, operationCargoContract, ...payload } = cargoFormData;
    const cpDate = payload.cpDate || payload.contractDate || payload.cp_date || moment().format("YYYY-MM-DD");
    const cargoKey = payload?.cargoDetails?.customerCargo
      ? "customerCargo"
      : payload?.cargoDetails?.clientQuery
        ? "clientQuery"
        : null;

    const finalData = {
      ...payload,
      cpDate,
      cargoDetails: cargoKey
        ? {
          ...payload.cargoDetails,
          [cargoKey]: {
            ...payload.cargoDetails[cargoKey],
            cargoList,
          },
        }
        : {
          ...payload.cargoDetails,
          cargoList,
        },
    };
    if (!finalData.contractName) {
      toastError("Contract Name is Required");
      return;
    }

    const formPayload = new FormData();

    if (cargoTextContract) {
      const fileType = cargoTextContract.type || "application/octet-stream";
      const fileName = cargoTextContract.name || "contract";

      const textBlob = new Blob([cargoTextContract], { type: fileType });
      const textFile = new File([textBlob], fileName, { type: fileType });

      formPayload.append("files", textFile);
      formPayload.append(
        "textContractMetadata",
        JSON.stringify({ fileType: "textContract" })
      );
    }

    // Append attachments if available
    if (cargoAttachments?.length) {
      cargoAttachments.forEach((file) => {
        formPayload.append("files", file);
      });
    }

    // Append form data
    formPayload.append(
      "data",
      JSON.stringify({
        ...finalData,
        cpDate,
        attachments: prevAttachments.attachments,
        textContract: prevAttachments.textContract,
        organizationId,
      })
    );

    updateCargoContract({ _id }, formPayload)
      .then(() => {
        fetchCargoContracts(cargoFilters, false);
        setIsCargoEditing(false);
        setCargoAttachments([]);
        setCargoTextContract("");
        setPrevAttachments({
          attachments: [],
          textContract: "",
        });
        toastSuccess("Cargo Contract Updated successfully!!");
      })
      .catch((err) => {
        toastError(err.message);
      });
  };

  const handleUpdateVesselContract = () => {
    const { _id, ...payload } = vesselFormData;
    if (!payload.contractName) {
      toastError("Contract Name is Required");
      return;
    }
    const formPayload = new FormData();

    if (vesselTextContract) {
      const fileType = vesselTextContract.type || "application/octet-stream";
      const fileName = vesselTextContract.name || "contract";

      const textBlob = new Blob([vesselTextContract], { type: fileType });
      const textFile = new File([textBlob], fileName, { type: fileType });

      formPayload.append("files", textFile);
      formPayload.append(
        "textContractMetadata",
        JSON.stringify({ fileType: "textContract" })
      );
    }

    // Append attachments if available
    if (vesselAttachments?.length) {
      vesselAttachments.forEach((file) => {
        formPayload.append("files", file);
      });
    }

    // Reconstruct payload to ensure vesselDetails and vesselOutContract are intact
    const finalPayload = { ...payload };
    
    // Extract safe fields to avoid circular references
    const { 
      vesselDetails, 
      vesselOutContract, 
      actualVesselContract, 
      operationVesselContract,
      vesselData,
      cargoDetails,
      ...safeFields 
    } = payload;

    finalPayload.vesselDetails = {
      ...(finalPayload.vesselDetails || {}),
      ...safeFields
    };


    formPayload.append(
      "data",
      JSON.stringify({
        ...finalPayload,
        attachments: prevAttachments.attachments,
        textContract: prevAttachments.textContract,
        organizationId,
      })
    );

    updateVesselContract({ _id }, formPayload)
      .then(() => {
        fetchVesselContracts(vesselFilters, false);
        setIsVesselEditing(false);
        setVesselAttachments([]);
        setVesselTextContract("");
        setPrevAttachments({
          attachments: [],
          textContract: "",
        });
        toastSuccess("Vessel Contract Updated successfully!!");
      })
      .catch((err) => {
        toastError(err.message);
      });
  };

  const handleDeleteCargoContract = (id) => {
    setCargoDeleteComformationModelOpen(true);
    setSelectedCargoForDelete(id);
  };

  const handleDeleteVesselContract = (id) => {
    setVesselDeleteComformationModelOpen(true);
    setSelectedVesselForDelete(id);
  };

  const handleDeleteEstimateContract = (id) => {
    setEstimateDeleteComformationModelOpen(true);
    setSelectedEstimateForDelete(id);
  };

  const handleConfirmDeleteCargoContract = () => {
    deleteCargoContract({ _id: selectedCargoForDelete })
      .then(() => {
        fetchCargoContracts(cargoFilters, false);
        setCargoDeleteComformationModelOpen(false);
        setSelectedCargoForDelete(null);
        toastSuccess("Cargo Contract Deleted successfully!!");
      })
      .catch((err) => {
        toastError(err.message);
      });
  };

  const handleConfirmDeleteVesselContract = () => {
    deleteVesselContract({ _id: selectedVesselForDelete })
      .then(() => {
        fetchVesselContracts(vesselFilters, false);
        setVesselDeleteComformationModelOpen(false);
        setSelectedVesselForDelete(null);
        toastSuccess("Vessel Contract Deleted successfully!!");
      })
      .catch((err) => {
        toastError(err.message);
      });
  };

  const handleConfirmDeleteEstimateContract = () => {
    deleteEstimateContract({ _id: selectedEstimateForDelete })
      .then(() => {
        fetchEstimateContracts(estimateFilters, false);
        setEstimateDeleteComformationModelOpen(false);
        setSelectedEstimateForDelete(null);
        toastSuccess("Estimate Contract Deleted successfully!!");
      })
      .catch((err) => {
        toastError(err.message);
      });
  };

  const handleContractShare = async (id = "", data = {}) => {
    handleSetLoader(true);
    try {
      let fullData = data;
      if (subTab === "1") {
        const res = await getCargoContractById(id);
        fullData = res.data || data;
      } else if (subTab === "2") {
        const res = await getVesselContractById(id);
        fullData = res.data || data;
      } else if (subTab === "3") {
        const res = await getEstimateContractById({ id });
        fullData = res.data || data;
      }

      const {
        _id,
        userId,
        access,
        createdAt,
        updateAt,
        contractName,
        estimateLabel,
        ...rest
      } = fullData;

      const sharedData = subTab === "3" ? { ...rest, contractName } : rest;

      setSelectedContractForShare({ _id: id, data: sharedData });
      if (subTab === "1") {
        setCargoShareModelOpen(true);
      } else if (subTab === "2") {
        setVesselShareModelOpen(true);
      } else if (subTab === "3") {
        setEstimateShareModelOpen(true);
      }
    } catch (err) {
      toastError("Failed to fetch full contract details for sharing");
    } finally {
      handleSetLoader(false);
    }
  };

  const handleViewSavedContract = (id, contractType) => {
    if (contractType === "cargo-cargo") {
      window.open(`/cargo-cargo-contract/${id}`, "_blank");
    } else if (contractType === "vessel-vessel") {
      window.open(`/vessel-vessel-contract/${id}`, "_blank");
    } else {
      window.open(`/saved-contracts/${id}`, "_blank");
    }
  };

  const handleView = async (data) => {
    handleSetLoader(true);
    try {
      let fullData = data;
      const targetId = data?._id || data?.contractId || data?.cargoId || data?.vesselId || data?.id;
      if (subTab === "1" && targetId) {
        const res = await getCargoContractById(targetId);
        fullData = res.data || data;
      } else if (subTab === "2" && targetId) {
        const res = await getVesselContractById(targetId);
        fullData = res.data || data;
      }

      const { contractId, contractType } = fullData;
      if (subTab === "2") {
        const vesselFormDataObj = mergeVesselContractData(fullData);

        setIsVesselViewModelOpen(true);
        setCurrentContract({
          ...vesselFormDataObj,
          contractId: fullData._id || contractId,
          contractType: fullData.contractType || contractType,
        });
      } else {
        const customerCargoObj =
          fullData?.cargoDetails?.customerCargo ||
          fullData?.cargoDetails ||
          fullData?.customerCargo ||
          fullData;

        const rawCargoList =
          customerCargoObj?.cargoList || fullData?.cargoList || [];

        setSelectedPorts(
          rawCargoList?.filter((item) => item.operation !== "Commence") || []
        );

        setCurrentContract({
          ...fullData,
          ...customerCargoObj,
          contractId: fullData._id || contractId,
          contractType: fullData.contractType || contractType,
        });
        setIsCargoViewModelOpen(true);
      }
    } catch (err) {
      toastError("Failed to fetch full contract details for view");
    } finally {
      handleSetLoader(false);
    }
  };

  const handleCopyWarningModal = (type) => {
    setIsCopyWarningModalOpen({
      isOpen: true,
      type,
    });
  };

  const buildCopyVesselContractPayload = (
    vesselFormData,
  ) => {
    if (!vesselFormData || typeof vesselFormData !== "object") {
      throw new Error("Invalid vesselFormData");
    }

    const {
      contractType,
      actualVesselContract,
      vesselDetails: topLevelVesselDetails,
      _id: contractId,
    } = vesselFormData;

    const isOperationsStage = Boolean(
      actualVesselContract &&
      typeof actualVesselContract === "object" &&
      Object.keys(actualVesselContract).some(
        (key) => actualVesselContract[key] !== "" && actualVesselContract[key] !== null
      )
    );

    let source;
    let cargoContract = null;

    if (isOperationsStage) {
      if (contractType === "vessel-cargo") {
        const cargoContractId = estimateContractDetails.find(
          (c) => c.vesselContractId === contractId
        )?.cargoContractId;

        cargoContract = cargoContractDetails.find(
          (c) => c._id === cargoContractId
        );

        if (!cargoContract?.actualCargoContract) {
          throw new Error("Missing actualCargoContract");
        }

        source = actualVesselContract;
      } else {
        source = actualVesselContract;
      }
    } else {
      if (contractType === "vessel-cargo") {
        const cargoContractId = estimateContractDetails.find(
          (c) => c.vesselContractId === contractId
        )?.cargoContractId;

        cargoContract = cargoContractDetails.find(
          (c) => c._id === cargoContractId
        );

        if (!cargoContract) {
          throw new Error("Missing cargoContract");
        }

        source = vesselFormData;
      } else {
        source = vesselFormData;
      }
    }

    const {
      _id,
      __v,
      status,
      access,
      createdAt,
      updatedAt,
      updateAt,
      estId,
      actualVesselContract: _avc,
      operationVesselContract: _ovc,
      vesselContractId,
      vesselInvoiceDetails,
      vesselInvoiceDetailsOut,
      contractType: _type,
      vesselOutContract,
      ...cleanContract
    } = source;

    const vesselDetails = isOperationsStage
      ? { ...topLevelVesselDetails, ...cleanContract.vesselDetails }
      : topLevelVesselDetails;

    delete cleanContract.vesselDetails;

    let updatedVesselDetails = { ...vesselDetails };

    const buildCargoRow = (c = {}, operation) => ({
      _id: uuidv4(),

      label: c.label ?? null,
      voyType: c.voyType ?? null,
      account: c.account ?? null,
      firstLoadPort: c.firstLoadPort ?? null,
      lastDischargePort: c.lastDischargePort ?? null,
      cargo: c.cargo ?? null,
      freight: c.freight ?? null,
      tcEq: c.tcEq ?? null,
      tcGbb: c.tcGbb ?? null,
      hire: c.hire ?? null,
      hireGbb: c.hireGbb ?? null,
      profit: c.profit ?? null,
      duration: c.duration ?? null,
      freightMode: c.freightMode ?? null,
      laycanBegin: c.laycanBegin ?? null,
      laycanEnd: c.laycanEnd ?? null,
      broker: c.broker ?? null,
      lumpsumFreight: c.lumpsumFreight ?? null,
      stowFactor: c.stowFactor ?? null,
      multiParcelMode: c.multiParcelMode ?? false,

      operation,
      port: c.port ?? null,
      cargoQty: c.cargoQty ?? 0,
      tolerance: c.tolerance ?? null,
      rate: c.rate ?? 0,
      terms: c.terms ?? "SHINC",
      turnTime: c.turnTime ?? null,
      pdaRemarks: c.pdaRemarks ?? null,
      grade: c.grade ?? null,
      adcom: c.adcom ?? null,
      brokerage: c.brokerage ?? null,
      ttlComm: c.ttlComm ?? null,
      netFrt: c.netFrt ?? null,
      min: c.min ?? null,
      max: c.max ?? null,
      factor: c.factor ?? null,
      seaTime: c.seaTime ?? null,
      portExp: c.portExp ?? null,
      portStay: c.portStay ?? null,
      extraDays: c.extraDays ?? null,
      supply: c.supply ?? null,
      sulfur: c.sulfur ?? null,
      loadline: c.loadline ?? null,
      dwf: c.dwf ?? null,
      draftRes: c.draftRes ?? null,
      waterDensity: c.waterDensity ?? null,
      other: c.other ?? null,
      dischargeQty: c.dischargeQty ?? null,
      speedNormal: c.speedNormal ?? null,
      speedECA: c.speedECA ?? null,
      cargoTx: c.cargoTx ?? null,
      cargoTxOverriddenValue: c.cargoTxOverriddenValue ?? null,
      arrivalTime: c.arrivalTime ?? null,
      departureTime: c.departureTime ?? null,

      arrivalHsfo: c.arrivalHsfo ?? 0,
      arrivalLsfo: c.arrivalLsfo ?? 0,
      arrivalMgo: c.arrivalMgo ?? 0,
      departureHsfo: c.departureHsfo ?? 0,
      departureLsfo: c.departureLsfo ?? 0,
      departureMgo: c.departureMgo ?? 0,

      index: c.index ?? null,
      lbmarker: c.lbmarker ?? null,
      lat: c.lat ?? null,
      lng: c.lng ?? null,
      country: c.country ?? null,
      portId: c.portId ?? null,
      notes: c.notes ?? null,

      cargoDetails: {
        distNormal: 0,
        distEca: 0,
        bnkrFactor: c.cargoDetails?.bnkrFactor ?? 0,
        speedReduce: c.cargoDetails?.speedReduce ?? 0,
        speedFactor: c.cargoDetails?.speedFactor ?? 0,

        arrivalBunkersHSFO: c.cargoDetails?.arrivalBunkersHSFO ?? 0,
        arrivalBunkersLSFO: c.cargoDetails?.arrivalBunkersLSFO ?? 0,
        arrivalBunkersMGO: c.cargoDetails?.arrivalBunkersMGO ?? 0,

        bunkerSuppliedHSFO: c.cargoDetails?.bunkerSuppliedHSFO ?? 0,
        bunkerSuppliedLSFO: c.cargoDetails?.bunkerSuppliedLSFO ?? 0,
        bunkerSuppliedMGO: c.cargoDetails?.bunkerSuppliedMGO ?? 0,

        bunkerNonScrubberHSFO: c.cargoDetails?.bunkerNonScrubberHSFO ?? 0,
        bunkerNonScrubberLSFO: c.cargoDetails?.bunkerNonScrubberLSFO ?? 0,
        bunkerNonScrubberMGO: c.cargoDetails?.bunkerNonScrubberMGO ?? 0,

        bunkerScrubberHSFO: c.cargoDetails?.bunkerScrubberHSFO ?? 0,
        bunkerScrubberLSFO: c.cargoDetails?.bunkerScrubberLSFO ?? 0,
        bunkerScrubberMGO: c.cargoDetails?.bunkerScrubberMGO ?? 0,

        reserve: c.cargoDetails?.reserve ?? "Supply",
        paidBy: c.cargoDetails?.paidBy ?? "Owner",
        fuelPriceType0Hsfo: c.cargoDetails?.fuelPriceType0Hsfo ?? null,
        fuelPriceType0Lsfo: c.cargoDetails?.fuelPriceType0Lsfo ?? null,
        fuelPriceType0Mgo: c.cargoDetails?.fuelPriceType0Mgo ?? null,
        fuelPriceType1Hsfo: c.cargoDetails?.fuelPriceType1Hsfo ?? null,
        fuelPriceType1Lsfo: c.cargoDetails?.fuelPriceType1Lsfo ?? null,
        fuelPriceType1Mgo: c.cargoDetails?.fuelPriceType1Mgo ?? null,
        fuelPriceType2Hsfo: c.cargoDetails?.fuelPriceType2Hsfo ?? null,
        fuelPriceType2Lsfo: c.cargoDetails?.fuelPriceType2Lsfo ?? null,
        fuelPriceType2Mgo: c.cargoDetails?.fuelPriceType2Mgo ?? null,
        fuelPriceType3Hsfo: c.cargoDetails?.fuelPriceType3Hsfo ?? null,
        fuelPriceType3Lsfo: c.cargoDetails?.fuelPriceType3Lsfo ?? null,
        fuelPriceType3Mgo: c.cargoDetails?.fuelPriceType3Mgo ?? null,
        fuelPriceType4Hsfo: c.cargoDetails?.fuelPriceType4Hsfo ?? null,
        fuelPriceType4Lsfo: c.cargoDetails?.fuelPriceType4Lsfo ?? null,
        fuelPriceType4Mgo: c.cargoDetails?.fuelPriceType4Mgo ?? null,
      },


      distanceOverridden: c.distanceOverridden ?? false,
      isExtra: c.isExtra ?? false,
      version: c.version ?? 1,
      system: c.system ?? true,
    });

    const sourceCargoList =
      contractType === "vessel-cargo"
        ? isOperationsStage
          ? cargoContract.actualCargoContract.cargoDetails.cargoList
          : cargoContract.cargoDetails.cargoList || cargoContract.cargoDetails?.customerCargo?.cargoList || []
        : vesselDetails?.clientQuery?.cargoList || [];
    if (sourceCargoList?.length) {
      const last = sourceCargoList[sourceCargoList.length - 1];

      updatedVesselDetails.clientQuery = {
        ...vesselDetails.clientQuery,
        cargoList: [
          buildCargoRow(last, "Commence"),
          buildCargoRow(last, "Loading"),
          buildCargoRow(last, "Discharging"),
        ],
      };
      updatedVesselDetails.port = last.port || null;
      updatedVesselDetails.lat = last.lat || null;
      updatedVesselDetails.lng = last.lng || null;
    }

    return {
      ...cleanContract,
      contractId: contractId || _id,
      vesselDetails: updatedVesselDetails,
    };
  };


  const handleCopyContract = async () => {
    try {
      if (subTab === "1") {
        const {
          _id,
          status,
          contractType,
          access,
          createdAt,
          updateAt,
          estId,
          ...payload
        } = cargoFormData;
        await createCargoContract(payload);
        await fetchCargoContracts();
        toastSuccess("Cargo Contract Copied SuccessFully");
      } else if (subTab === "2") {
        const payload = buildCopyVesselContractPayload(vesselFormData);
        await createVesselContract(payload);
        await fetchVesselContracts();
        toastSuccess("Vessel Contract Copied Successfully");
      }
      handleCloseEditModel();
    } catch (error) {
      toastError(
        error?.response?.message ||
        error?.message ||
        error ||
        "Failed to Copy Contract"
      );
    }
  };

  const onCargoAnalysisClick = (id, { clientQuery }) => {
    clientQuery = clientQuery?.customerCargo ?? clientQuery;
    handleSetLoader(true, "Loading cargo analysis data...");

    getGeneralMasterData("cargo-analysis-vessel-list")
      .then((res) => {
        handleSetLoader(false);
        setCargoAnalysisStepper(true);
        setAnalysisVessel(res?.data?.list);
        setSelectedPorts(
          clientQuery?.cargoList?.filter(
            (item) => item.operation !== "Commence"
          )
        );
        setCargoAnalysisData({ clientQuery });
      })
      .catch((err) => {
        handleSetLoader(false);
        toastError(err?.data?.message || "Something went wrong");
      });
  };

  const handleUpdateCargo = () => {
    if (addQueryModalRef.current.onSubmitQuery) {
      addQueryModalRef.current.onSubmitQuery();
    }
  };

  const handleEditClosedContract = (id) => {
    setShowClosedContract({
      isOpen: true,
      id,
    });
  };

  const handleSortClick = (sortKey, type) => {
    const isVessel = type === "vessel";
    const isEstimate = type === "estimate";
    const filters = isVessel ? vesselFilters : isEstimate ? estimateFilters : cargoFilters;
    const setFilters = isVessel ? setVesselFilters : isEstimate ? setEstimateFilters : setCargoFilters;

    let newSortDirection = "asc";
    const defaultSortKey = isEstimate ? "updatedAt" : "createdAt";

    if (filters.sortBy === sortKey) {
      if (filters.sortDirection === "asc") newSortDirection = "desc";
      else if (filters.sortDirection === "desc") {
        newSortDirection = sortKey === defaultSortKey ? "asc" : "";
      }
    } else {
      newSortDirection = sortKey === defaultSortKey ? "desc" : "asc";
    }

    let apiFilters = { ...filters, sortBy: sortKey, sortDirection: newSortDirection, offset: 1 };
    if (!newSortDirection) {
      apiFilters.sortBy = defaultSortKey;
      apiFilters.sortDirection = "desc";
    }

    setFilters(apiFilters);
    if (isVessel) {
      fetchVesselContracts(apiFilters);
    } else if (isEstimate) {
      fetchEstimateContracts(apiFilters);
    } else {
      fetchCargoContracts(apiFilters);
    }
  };

  const renderCargoContractsTable = () => {
    return (
      <TableContainer component={Paper}>
        {cargoFilters?.totalItems > cargoFilters?.limit && (
          <CustomPagination
            onChangePagination={handlePagination}
            filters={cargoFilters}
            totalPage={cargoFilters?.totalItems}
          />
        )}
        <Table className="universal-table fit-content-mobile">
          <TableHead>
            <TableRow>
              <TableCell className="table-cell">No.</TableCell>
              <TableCell className="table-cell" style={{ cursor: "pointer" }} onClick={() => handleSortClick("contractType", "cargo")}>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  Operation Type
                  <div style={{ color: cargoFilters.sortBy === "contractType" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                    {cargoFilters.sortBy === "contractType" && cargoFilters.sortDirection === "desc" ? <LuArrowDown size={14} /> : cargoFilters.sortBy === "contractType" && cargoFilters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                  </div>
                </div>
              </TableCell>
              <TableCell className="table-cell" style={{ cursor: "pointer" }} onClick={() => handleSortClick("status", "cargo")}>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  Status
                  <div style={{ color: cargoFilters.sortBy === "status" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                    {cargoFilters.sortBy === "status" && cargoFilters.sortDirection === "desc" ? <LuArrowDown size={14} /> : cargoFilters.sortBy === "status" && cargoFilters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                  </div>
                </div>
              </TableCell>
              <TableCell className="table-cell" style={{ cursor: "pointer" }} onClick={() => handleSortClick("contractName", "cargo")}>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  Operation Name
                  <div style={{ color: cargoFilters.sortBy === "contractName" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                    {cargoFilters.sortBy === "contractName" && cargoFilters.sortDirection === "desc" ? <LuArrowDown size={14} /> : cargoFilters.sortBy === "contractName" && cargoFilters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                  </div>
                </div>
              </TableCell>
              <TableCell className="table-cell" style={{ cursor: "pointer" }} onClick={() => handleSortClick("cargoDetails.name", "cargo")}>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  Cargo Name
                  <div style={{ color: cargoFilters.sortBy === "cargoDetails.name" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                    {cargoFilters.sortBy === "cargoDetails.name" && cargoFilters.sortDirection === "desc" ? <LuArrowDown size={14} /> : cargoFilters.sortBy === "cargoDetails.name" && cargoFilters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                  </div>
                </div>
              </TableCell>
              <TableCell className="table-cell">First Load Port</TableCell>
              <TableCell className="table-cell">Last Discharge Port</TableCell>
              <TableCell className="table-cell" style={{ cursor: "pointer" }} onClick={() => handleSortClick("cpDate", "cargo")}>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  CP Date
                  <div style={{ color: cargoFilters.sortBy === "cpDate" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                    {cargoFilters.sortBy === "cpDate" && cargoFilters.sortDirection === "desc" ? <LuArrowDown size={14} /> : cargoFilters.sortBy === "cpDate" && cargoFilters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                  </div>
                </div>
              </TableCell>
              <TableCell className="table-cell" style={{ cursor: "pointer" }} onClick={() => handleSortClick("createdAt", "cargo")}>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  Created On
                  <div style={{ color: cargoFilters.sortBy === "createdAt" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                    {cargoFilters.sortBy === "createdAt" && cargoFilters.sortDirection === "desc" ? <LuArrowDown size={14} /> : cargoFilters.sortBy === "createdAt" && cargoFilters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                  </div>
                </div>
              </TableCell>
              <TableCell className="table-cell">Contracting Company</TableCell>
              <TableCell className="table-cell w-[120px]">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoadingCargo ? (
              <TableRow>
                <TableCell colSpan={12} align="center" className="!bg-white">
                  <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                    {cargoContractDetails?.length > 0 && <CircularProgress />}
                  </Box>
                </TableCell>
              </TableRow>
            ) : cargoContractDetails?.length ? cargoContractDetails?.map((contract, index) => {
              const cargoDetails = contract?.cargoDetails || {};
              const customerCargoExists =
                cargoDetails?.customerCargo?.cargoList?.length > 0;
              const regularCargoExists = cargoDetails?.cargoList?.length > 0;

              const firstPort = customerCargoExists
                ? cargoDetails.customerCargo.cargoList[0]?.port
                : regularCargoExists
                  ? cargoDetails.cargoList[0]?.port
                  : null;

              const lastPort = customerCargoExists
                ? cargoDetails.customerCargo.cargoList[
                  cargoDetails.customerCargo.cargoList.length - 1
                ]?.port
                : regularCargoExists
                  ? cargoDetails.cargoList[cargoDetails.cargoList.length - 1]
                    ?.port
                  : null;

              const renderActions = (contract) => {
                if (mainTab === 1) {
                  return (
                    <div
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "1px",
                        flexWrap: "nowrap",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <span
                        className="pending-steper validate-icon-vessel-manager border-none"
                        style={{ display: "inline-flex", alignItems: "center" }}
                      >
                        <SaveIcon
                          color="primary"
                          onClick={() => handleContractShare(contract?._id, contract)}
                          style={{ cursor: "pointer" }}
                        />
                      </span>

                      <div className="tooltip-notification-vessel-manager">
                        <p>Copy Contract</p>
                      </div>

                      {userId === contract.userId && (
                        <>
                          <span
                            className="pending-steper validate-icon-vessel-manager border-none"
                            style={{ display: "inline-flex", alignItems: "center" }}
                          >
                            <Delete
                              style={{ color: "red", cursor: "pointer" }}
                              onClick={() => handleDeleteCargoContract(contract?._id)}
                            />
                          </span>

                          <div className="tooltip-notification-vessel-manager">
                            <p>Delete Contract</p>
                          </div>
                        </>
                      )}
                    </div>
                  );
                }

                return (
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "1px",
                      flexWrap: "nowrap",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <Tooltip text="Update Contract" position="left">
                      <button
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          height: "28px",
                          width: "28px",
                          justifyContent: "center",
                        }}
                        onClick={() => handleContractEdit(contract)}
                      >
                        <VisibilityIcon style={{ color: "#313C4C", cursor: "pointer" }} />
                      </button>
                    </Tooltip>

                    {contract?.status === "open" && (
                      <>
                        <Tooltip text="Create Estimate Contract" position="left">
                          <button
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              height: "28px",
                              width: "28px",
                              justifyContent: "center",
                            }}
                            onClick={() =>
                              onClickSaveCargoVesselEstimate(contract?._id, contract)
                            }
                          >
                            <OpenInNew style={{ color: "black", cursor: "pointer" }} />
                          </button>
                        </Tooltip>

                        <Tooltip text="Delete Contract" position="left">
                          <button
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              height: "28px",
                              width: "28px",
                              justifyContent: "center",
                            }}
                            onClick={() => handleDeleteCargoContract(contract?._id)}
                          >
                            <Delete style={{ color: "red", cursor: "pointer" }} />
                          </button>
                        </Tooltip>
                      </>
                    )}

                    <div
                      className="relative"
                      style={{ display: "inline-flex", alignItems: "center" }}
                    >
                      <IconButton
                        onClick={(e) => handleMenuOpen(e, contract, cargoDetails)}
                        size="small"
                        className="p-0"
                        style={{
                          height: "28px",
                          width: "18px",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <MoreVert fontSize="small" color="primary" />
                      </IconButton>

                      <Menu
                        anchorEl={anchorEl}
                        open={menuContractId === contract._id}
                        onClose={handleMenuClose}
                        PaperProps={menuPaperProps}
                        MenuListProps={menuListProps}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                      >
                        <MenuItem
                          style={menuItemStyle}
                          onClick={() => {
                            handleView(
                              selectedItem?.subItem
                                ? {
                                  ...selectedItem?.subItem,
                                  contractType: selectedItem?.item?.contractType,
                                  contractId: selectedItem?.item?._id,
                                  _id: selectedItem?.item?._id || selectedItem?.subItem?._id,
                                }
                                : selectedItem?.item
                            );
                            handleMenuClose();
                          }}
                        >
                          <LuPencil size={14} color="#000" />
                          Update Cargo
                        </MenuItem>

                        <MenuItem
                          style={menuItemStyle}
                          onClick={() => {
                            handleContractShare(contract._id, contract);
                            handleMenuClose();
                          }}
                        >
                          <LuShare2 size={14} color="#000" />
                          Share with Your Team
                        </MenuItem>

                        <MenuItem
                          style={menuItemStyle}
                          onClick={() => {
                            onCargoAnalysisClick(contract._id, {
                              clientQuery: cargoDetails,
                            });
                            handleMenuClose();
                          }}
                        >
                          <LuSearch size={14} color="#000" />
                          Cargo Analysis
                        </MenuItem>
                      </Menu>
                    </div>
                  </div>
                );
              };


              return (
                <TableRow
                  key={index}
                  className="text-[12px] cursor-pointer hover:bg-gray-50"
                  onDoubleClick={() => handleContractEdit(contract)}
                >
                  <TableCell className="text-[12px]">
                    {(cargoFilters.offset - 1) * cargoFilters.limit + index + 1}
                  </TableCell>
                  <TableCell className="text-[12px]">{contract.contractType || "-"}</TableCell>
                  <TableCell className="text-[12px]">{contract.status || "-"}</TableCell>
                  <TableCell className="text-[12px]">{contract?.contractName || "-"}</TableCell>
                  <TableCell className="text-[12px]">{cargoDetails.name || "-"}</TableCell>
                  <TableCell className="text-[12px]">{firstPort || "-"}</TableCell>
                  <TableCell className="text-[12px]">{lastPort || "-"}</TableCell>
                  <TableCell className="text-[12px]">
                    {moment(contract?.cpDate).format("DD-MM-YYYY") || "-"}
                  </TableCell>
                  <TableCell className="text-[12px]">
                    {moment(cargoDetails.createdAt).format("DD-MM-YYYY") || "-"}
                  </TableCell>
                  <TableCell className="text-[12px]">{contract?.contractingCompany || "-"}</TableCell>
                  <TableCell className="text-[12px]">{renderActions(contract)}</TableCell>
                </TableRow>
              );
            }) : hasFetchedCargo ? (
              <TableRow>
                <TableCell colSpan={12} align="center" className="!bg-white">
                  <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                    No Cargo contracts found
                  </Box>
                </TableCell>
              </TableRow>
            ) : null}
          </TableBody>
        </Table>
        {cargoFilters?.totalItems > cargoFilters?.limit && (
          <CustomPagination
            onChangePagination={handlePagination}
            filters={cargoFilters}
            totalPage={cargoFilters?.totalItems}
          />
        )}
      </TableContainer>
    );
  };

  const renderVesselContractsTable = () => {
    return (
      <TableContainer component={Paper}>
        {vesselFilters?.totalItems > vesselFilters?.limit && (
          <CustomPagination
            onChangePagination={handlePagination}
            filters={vesselFilters}
            totalPage={vesselFilters?.totalItems}
          />
        )}
        <Table className="universal-table fit-content-mobile">
          <TableHead>
            <TableRow>
              <TableCell className="table-cell">No.</TableCell>
              <TableCell className="table-cell" style={{ cursor: "pointer" }} onClick={() => handleSortClick("contractType", "vessel")}>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  Operation Type
                  <div style={{ color: vesselFilters.sortBy === "contractType" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                    {vesselFilters.sortBy === "contractType" && vesselFilters.sortDirection === "desc" ? <LuArrowDown size={14} /> : vesselFilters.sortBy === "contractType" && vesselFilters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                  </div>
                </div>
              </TableCell>
              <TableCell className="table-cell" style={{ cursor: "pointer" }} onClick={() => handleSortClick("status", "vessel")}>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  Status
                  <div style={{ color: vesselFilters.sortBy === "status" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                    {vesselFilters.sortBy === "status" && vesselFilters.sortDirection === "desc" ? <LuArrowDown size={14} /> : vesselFilters.sortBy === "status" && vesselFilters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                  </div>
                </div>
              </TableCell>
              <TableCell className="table-cell" style={{ cursor: "pointer" }} onClick={() => handleSortClick("contractName", "vessel")}>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  Operation Name
                  <div style={{ color: vesselFilters.sortBy === "contractName" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                    {vesselFilters.sortBy === "contractName" && vesselFilters.sortDirection === "desc" ? <LuArrowDown size={14} /> : vesselFilters.sortBy === "contractName" && vesselFilters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                  </div>
                </div>
              </TableCell>
              <TableCell className="table-cell">Vessel Name</TableCell>
              <TableCell className="table-cell">Port</TableCell>
              <TableCell className="table-cell">Vessel Fixture ID</TableCell>
              <TableCell className="table-cell" style={{ cursor: "pointer" }} onClick={() => handleSortClick("cpDate", "vessel")}>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  CP Date
                  <div style={{ color: vesselFilters.sortBy === "cpDate" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                    {vesselFilters.sortBy === "cpDate" && vesselFilters.sortDirection === "desc" ? <LuArrowDown size={14} /> : vesselFilters.sortBy === "cpDate" && vesselFilters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                  </div>
                </div>
              </TableCell>
              <TableCell className="table-cell">Contracting Company</TableCell>
              <TableCell className="table-cell">Chartering PIC</TableCell>
              <TableCell className="table-cell  w-[120px]">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoadingVessel ? (
              <TableRow>
                <TableCell colSpan={12} align="center" className="!bg-white">
                  <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                    {vesselContractDetails?.length > 0 && <CircularProgress />}
                  </Box>
                </TableCell>
              </TableRow>
            ) : vesselContractDetails?.length ? vesselContractDetails?.map((contract, index) => {
              // Access nested vessel details
              const vesselData =
                contract?.vesselDetails?.fleetList?.[0] ??
                contract?.vesselDetails;
              let vesselName = null;
              if (vesselData?.vessel) {
                try {
                  vesselName = typeof vesselData.vessel === "string"
                    ? JSON.parse(vesselData.vessel)?.vesselName
                    : vesselData.vessel?.vesselName;
                } catch (e) {
                  console.error("Error parsing vessel:", e);
                }
              }

              return (
                <TableRow
                  key={index}
                  className="text-[12px] cursor-pointer hover:bg-gray-50"
                  onDoubleClick={() => handleContractEdit(contract)}
                >
                  <TableCell className="text-[12px]">
                    {(vesselFilters.offset - 1) * vesselFilters.limit +
                      index +
                      1}
                  </TableCell>
                  <TableCell className="text-[12px]">{contract?.contractType || "-"}</TableCell>
                  <TableCell className="text-[12px]">{contract.status || "-"}</TableCell>
                  <TableCell className="text-[12px]">{contract?.contractName}</TableCell>
                  <TableCell className="text-[12px]">{vesselName || "-"}</TableCell>
                  <TableCell className="text-[12px]">{vesselData?.port || "-"}</TableCell>
                  <TableCell className="text-[12px]">{contract?.vesselFixtureId || "-"}</TableCell>
                  <TableCell className="text-[12px]">
                    {moment(contract?.cpDate).format("DD-MM-YYYY")}
                  </TableCell>
                  <TableCell className="text-[12px]">{contract?.contractingCompany || "-"}</TableCell>
                  <TableCell className="text-[12px]">{contract?.charteringPIC || "-"}</TableCell>
                  <TableCell className="text-[12px] whitespace-nowrap">
                    {mainTab === 1 ? (
                      <div
                        className="flex items-center flex-nowrap"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {/* Copy */}
                        <span
                          className="pending-steper validate-icon-vessel-manager border-none"
                          style={{
                            width: "28px",
                            height: "28px",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <SaveIcon
                            color="primary"
                            onClick={() => handleContractShare(contract?._id, contract)}
                            style={{ cursor: "pointer" }}
                          />
                          <div className="tooltip-notification-vessel-manager">
                            <p>Copy Contract</p>
                          </div>
                        </span>

                        {/* Delete */}
                        {userId === contract.userId && (
                          <span
                            className="pending-steper validate-icon-vessel-manager border-none"
                            style={{
                              width: "28px",
                              height: "28px",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Delete
                              style={{ color: "red", cursor: "pointer" }}
                              onClick={() => handleDeleteVesselContract(contract?._id)}
                            />
                            <div className="tooltip-notification-vessel-manager">
                              <p>Delete Contract</p>
                            </div>
                          </span>
                        )}
                      </div>
                    ) : (
                      <div
                        className="flex items-center flex-nowrap"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {/* Update */}
                        <Tooltip text="Update Contract" position="left">
                          <button
                            style={{
                              width: "28px",
                              height: "28px",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            onClick={() => handleContractEdit(contract)}
                          >
                            <VisibilityIcon style={{ color: "#313C4C", cursor: "pointer" }} />
                          </button>
                        </Tooltip>

                        {/* Create Estimate */}
                        {contract?.status === "open" && (
                          <>
                            <Tooltip text="Create Estimate Contract" position="left">
                              <button
                                style={{
                                  width: "28px",
                                  height: "28px",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                                onClick={() =>
                                  onClickSaveCargoVesselEstimate(contract?._id, contract)
                                }
                              >
                                <OpenInNew style={{ color: "black", cursor: "pointer" }} />
                              </button>
                            </Tooltip>

                            {/* Delete */}
                            <Tooltip text="Delete Contract" position="left">
                              <button
                                style={{
                                  width: "28px",
                                  height: "28px",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                                onClick={() => handleDeleteVesselContract(contract?._id)}
                              >
                                <Delete style={{ color: "red", cursor: "pointer" }} />
                              </button>
                            </Tooltip>
                          </>
                        )}

                        {/* Menu */}
                        <div
                          className="relative"
                          style={{
                            width: "28px",
                            height: "28px",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <IconButton
                            onClick={(e) => handleMenuOpen(e, contract, vesselData)}
                            size="small"
                            className="p-0"
                            style={{
                              width: "10px",
                              height: "28px",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <MoreVert fontSize="small" color="primary" />
                          </IconButton>
                        </div>
                      </div>
                    )}
                  </TableCell>

                </TableRow>
              );
            }) : hasFetchedVessel ? (
              <TableRow>
                <TableCell colSpan={12} align="center" className="!bg-white">
                  <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                    No Vessel contracts found
                  </Box>
                </TableCell>
              </TableRow>
            ) : null}
          </TableBody>
        </Table>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          PaperProps={menuPaperProps}
                        MenuListProps={menuListProps}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <MenuItem
                          style={menuItemStyle}
                          onClick={() => {
              handleView(
                selectedItem?.subItem
                  ? {
                    ...selectedItem?.subItem,
                    contractType: selectedItem?.item?.contractType,
                    contractId: selectedItem?.item?._id,
                    _id: selectedItem?.item?._id || selectedItem?.subItem?._id,
                  }
                  : selectedItem?.item
              );
              handleMenuClose();
            }}
          >
            <LuPencil size={14} color="#000" />
            Update Vessel
          </MenuItem>

          <MenuItem
                          style={menuItemStyle}
                          onClick={() => {
              handleContractShare(selectedItem?.item?._id, selectedItem?.item);
              handleMenuClose();
            }}
          >
            <LuShare2 size={14} color="#000" />
            Share with Your Team
          </MenuItem>
        </Menu>
        {vesselFilters?.totalItems > vesselFilters?.limit && (
          <CustomPagination
            onChangePagination={handlePagination}
            filters={vesselFilters}
            totalPage={vesselFilters?.totalItems}
          />
        )}
      </TableContainer>
    );
  };

  const renderEstimateTable = () => {
    return (
      <TableContainer component={Paper}>
        {estimateFilters?.totalItems > estimateFilters?.limit && (
          <CustomPagination
            onChangePagination={handlePagination}
            filters={estimateFilters}
            totalPage={estimateFilters?.totalItems}
          />
        )}
        <Table className="universal-table fit-content-mobile">
          <TableHead>
            <TableRow>
              <TableCell className="table-cell">No.</TableCell>
              {mainTab === 1 ? <TableCell className="table-cell">Estimate Label</TableCell> : ""}
              <TableCell className="table-cell" style={{ cursor: "pointer" }} onClick={() => handleSortClick("contractType", "estimate")}>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  Operation Type
                  <div style={{ color: estimateFilters.sortBy === "contractType" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                    {estimateFilters.sortBy === "contractType" && estimateFilters.sortDirection === "desc" ? <LuArrowDown size={14} /> : estimateFilters.sortBy === "contractType" && estimateFilters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                  </div>
                </div>
              </TableCell>
              <TableCell className="table-cell">Status</TableCell>
              <TableCell className="table-cell" style={{ cursor: "pointer" }} onClick={() => handleSortClick("contractName", "estimate")}>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  Operation Name
                  <div style={{ color: estimateFilters.sortBy === "contractName" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                    {estimateFilters.sortBy === "contractName" && estimateFilters.sortDirection === "desc" ? <LuArrowDown size={14} /> : estimateFilters.sortBy === "contractName" && estimateFilters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                  </div>
                </div>
              </TableCell>
              <TableCell className="table-cell">Vessel Name</TableCell>
              <TableCell className="table-cell">Cargo Name</TableCell>
              <TableCell className="table-cell">Opening Port</TableCell>
              <TableCell className="table-cell">First Load Port</TableCell>
              <TableCell className="table-cell">Last Discharge Port</TableCell>
              <TableCell className="table-cell" style={{ cursor: "pointer" }} onClick={() => handleSortClick("estimationDate", "estimate")}>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  Estimation Date
                  <div style={{ color: estimateFilters.sortBy === "estimationDate" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                    {estimateFilters.sortBy === "estimationDate" && estimateFilters.sortDirection === "desc" ? <LuArrowDown size={14} /> : estimateFilters.sortBy === "estimationDate" && estimateFilters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                  </div>
                </div>
              </TableCell>
              <TableCell className="table-cell" style={{ width: "120px" }}>Remark</TableCell>
              <TableCell className="table-cell  w-[120px]">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoadingEstimate ? (
              <TableRow>
                <TableCell colSpan={12} align="center" className="!bg-white">
                  <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                    {estimateContractDetails?.length > 0 && <CircularProgress />}
                  </Box>
                </TableCell>
              </TableRow>
            ) : estimateContractDetails?.length ? estimateContractDetails?.map((contract, index) => {
              const {
                contractType,
                _id,
                contractName,
                estimationDate,
                userId,
              } = contract;
              const isCargoCargo = contractType === "cargo-cargo";
              const isVesselVessel = contractType === "vessel-vessel";
              // Get vessel and cargo details based on contract type
              const cargo = isVesselVessel
                ? contract?.vesselContractDetails?.vesselDetails?.clientQuery
                : contract?.cargoContractDetails?.cargoDetails;

              const vessel =
                isVesselVessel &&
                  contract?.vesselContractDetails?.vesselDetails?.fleetList
                    ?.length
                  ? contract?.vesselContractDetails?.vesselDetails
                    ?.fleetList?.[0]
                  : contract?.vesselContractDetails?.vesselDetails;
              const vesselNames = cargo?.vesselData ? JSON.parse(cargo?.vesselData?.vessel || '{}')?.vesselName : null;
              let parsedPerfVesselName = null;
              if (cargo?.performingVessel) {
                try {
                  if (typeof cargo.performingVessel === "string" && cargo.performingVessel.trim().startsWith("{")) {
                    parsedPerfVesselName = JSON.parse(cargo.performingVessel)?.vesselName;
                  } else if (typeof cargo.performingVessel === "object") {
                    parsedPerfVesselName = cargo.performingVessel?.vesselName;
                  } else {
                    parsedPerfVesselName = cargo.performingVessel;
                  }
                } catch (e) {
                  parsedPerfVesselName = cargo.performingVessel;
                }
              }

              let estVesselName = null;
              if (vessel?.vessel) {
                try {
                  estVesselName = typeof vessel.vessel === "string"
                    ? JSON.parse(vessel.vessel)?.vesselName
                    : vessel.vessel?.vesselName;
                } catch (e) { }
              }

              const vesselName = isCargoCargo
                ? (parsedPerfVesselName || vesselNames)
                : (estVesselName || vesselNames);
              // Get port information
              const cargoList = isCargoCargo
                ? cargo?.customerCargo?.cargoList
                : cargo?.cargoList;

              const firstPort = cargoList?.[0]?.port || cargoList?.[1]?.port || "-";
              const lastPort = cargoList?.[cargoList?.length - 1]?.port || "-";

              return (
                <TableRow
                  key={index}
                  className="text-[12px] cursor-pointer hover:bg-gray-50"
                  onDoubleClick={() =>
                    handleViewSavedContract(_id, contractType)
                  }
                >
                  <TableCell className="text-[12px]">
                    {(estimateFilters.offset - 1) * estimateFilters.limit +
                      index +
                      1}
                  </TableCell>
                  <TableCell className="text-[12px]">{contractType || "-"}</TableCell>
                  <TableCell className="text-[12px]">{contract.status || "-"}</TableCell>

                  {mainTab === 1 && (
                    <TableCell className="text-[12px]">{contract?.estimateLabel}</TableCell>
                  )}

                  <TableCell className="text-[12px]">
                    <button
                      onClick={() => handleViewSavedContract(_id, contractType)}
                      className="text-blue underline cursor-pointer"
                    >
                      {contractName || "-"}
                    </button>
                  </TableCell>

                  <TableCell className="text-[12px]">{vesselName || "-"}</TableCell>
                  <TableCell className="text-[12px]">{cargo?.name || "-"}</TableCell>
                  <TableCell className="text-[12px]">{vessel?.vesselOpeningPort || "-"}</TableCell>
                  <TableCell className="text-[12px]">{firstPort}</TableCell>
                  <TableCell className="text-[12px]">{lastPort}</TableCell>
                  <TableCell className="text-[12px]">
                    {moment(estimationDate).format("DD-MM-YYYY")}
                  </TableCell>
                  <TableCell className="max-w-[120px]">
                    <Tooltip text={vessel?.remark || ""}>
                      <span className="block truncate max-w-[120px]">
                        {vessel?.remark || ""}
                      </span>
                    </Tooltip>
                  </TableCell>

                  {mainTab === 1 ? (
                    <TableCell>
                      <div
                        className="flex items-center flex-nowrap"
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        {/* Save Icon */}
                        <span
                          className="pending-steper validate-icon-vessel-manager border-none"
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "28px",
                            height: "28px",
                          }}
                        >
                          <SaveIcon
                            color="primary"
                            onClick={() => handleContractShare(_id, contract)}
                            style={{ cursor: "pointer" }}
                          />

                          <div className="tooltip-notification-vessel-manager">
                            <p>Copy Contract</p>
                          </div>
                        </span>

                        {/* Delete Icon (Only Owner) */}
                        {userId === contract.userId && (
                          <span
                            className="pending-steper validate-icon-vessel-manager border-none"
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "28px",
                              height: "28px",
                            }}
                          >
                            <Delete
                              style={{ color: "red", cursor: "pointer" }}
                              onClick={() => handleDeleteEstimateContract(_id)}
                            />
                            <div className="tooltip-notification-vessel-manager">
                              <p>Delete Contract</p>
                            </div>
                          </span>
                        )}
                      </div>
                    </TableCell>
                  ) : (
                    <TableCell>
                      <div
                        className="flex items-center flex-nowrap"
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        {/* Share with Team */}
                        <Tooltip text="Share with Your Team" position="left">
                          <button
                            style={{
                              width: "28px",
                              height: "28px",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            onClick={() => handleContractShare(_id, contract)}
                          >
                            <ShareIcon color="primary" />
                          </button>
                        </Tooltip>

                        {/* Edit closed contract */}
                        {contract?.contractType === "vessel-cargo" &&
                          contract.status === "close" && (
                            <Tooltip text="Edit Contract" position="left">
                              <button
                                style={{
                                  width: "28px",
                                  height: "28px",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                                onClick={() => handleEditClosedContract(_id)}
                              >
                                <Edit color="primary" className="cursor-pointer" />
                              </button>
                            </Tooltip>
                          )}

                        {/* Share to Operation */}
                        {contract.status !== "close" && (
                          <Tooltip text="Share to Operation" position="left">
                            <button
                              style={{
                                width: "28px",
                                height: "28px",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              onClick={() => {
                                setIsShareToOperationModelOpen(true);
                                setCurrentContract(contract?._id);
                              }}
                            >
                              <OpenInNew style={{ color: "black", cursor: "pointer" }} />
                            </button>
                          </Tooltip>
                        )}

                        {/* Delete */}
                        <Tooltip text="Delete Contract" position="left">
                          <button
                            style={{
                              width: "28px",
                              height: "28px",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            onClick={() => handleDeleteEstimateContract(_id)}
                          >
                            <Delete style={{ color: "red", cursor: "pointer" }} />
                          </button>
                        </Tooltip>
                      </div>
                    </TableCell>
                  )}

                </TableRow>
              );
            }) : hasFetchedEstimate ? (
              <TableRow>
                <TableCell colSpan={12} align="center" className="!bg-white">
                  <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                    No Estimate contracts found
                  </Box>
                </TableCell>
              </TableRow>
            ) : null}
          </TableBody>
        </Table>
        {estimateFilters?.totalItems > estimateFilters?.limit && (
          <CustomPagination
            onChangePagination={handlePagination}
            filters={estimateFilters}
            totalPage={estimateFilters?.totalItems}
          />
        )}
      </TableContainer>
    );
  };

  const DeleteConfirmationModal = () => {
    // Determine which modal is open
    const isCargoOpen = cargoDeleteComformationModelOpen;
    const isVesselOpen = vesselDeleteComformationModelOpen;
    const isEstimateOpen = estimateDeleteComformationModelOpen;

    // Set modal properties based on which one is open
    const modalOpen = isCargoOpen || isVesselOpen || isEstimateOpen;

    // Determine title, entity type, and handler functions based on which modal is open
    let title = "";
    let entityType = "";
    let handleClose = () => { };
    let handleConfirm = () => { };

    if (isCargoOpen) {
      title = "Delete Cargo Contract";
      entityType = "Cargo";
      handleClose = () => setCargoDeleteComformationModelOpen(false);
      handleConfirm = handleConfirmDeleteCargoContract;
    } else if (isVesselOpen) {
      title = "Delete Vessel Contract";
      entityType = "Vessel";
      handleClose = () => setVesselDeleteComformationModelOpen(false);
      handleConfirm = handleConfirmDeleteVesselContract;
    } else if (isEstimateOpen) {
      title = "Delete Estimate Contract";
      entityType = "Estimate";
      handleClose = () => setEstimateDeleteComformationModelOpen(false);
      handleConfirm = handleConfirmDeleteEstimateContract;
    }

    return (
      <CustomAddModal
        open={modalOpen}
        title={title}
        maxWidth="sm"
        saveLabel="Delete"
        handleClose={handleClose}
        onSubmitConfirm={handleConfirm}
      >
        <Box sx={{ textAlign: "center", p: 3 }}>
          <WarningOutlined color="error" sx={{ fontSize: 60, mb: 2 }} />
          <Typography variant="h6" gutterBottom>
            Are you sure you want to delete this {entityType} contract?
          </Typography>
          <Typography variant="body1" color="text.secondary">
            This action cannot be undone. All data associated with this contract
            will be permanently removed.
          </Typography>
        </Box>
      </CustomAddModal>
    );
  };

  const ShareModal = () => {
    // Determine which modal is open
    const isCargoOpen = cargoShareModelOpen;
    const isVesselOpen = vesselShareModelOpen;
    const isEstimateOpen = estimateShareModelOpen;

    // Set modal properties based on which one is open
    const modalOpen = isCargoOpen || isVesselOpen || isEstimateOpen;

    const isCopy = mainTab === 1;
    const contractTypeTitle = isCargoOpen
      ? "Cargo Contract"
      : isVesselOpen
        ? "Vessel Contract"
        : "Pre-Fix Estimate";
    const contractType = contractTypeTitle.toLowerCase();
    const destination = isCargoOpen
      ? "Cargo Contracts"
      : isVesselOpen
        ? "Vessel Contracts"
        : "Pre-Fix Estimate";
    const title = isCopy
      ? `Copy ${contractTypeTitle} to My Contracts`
      : `Share ${contractTypeTitle} with Team`;
    const guidance = isCopy
      ? `Create a new open personal copy of this ${contractType}. Find it in Contracts → My Contracts → ${destination}.`
      : isEstimateOpen
        ? "Create a team copy of this pre-fix estimate. Its team label appears in Contracts → All Contracts → Pre-Fix Estimate."
      : `Create a team copy of this ${contractType}. Find it in Contracts → All Contracts → ${destination}.`;
    const label = isEstimateOpen && !isCopy ? "Team label" : isEstimateOpen ? "Estimate name" : "Contract name";
    const placeholder = isEstimateOpen && !isCopy ? "Enter team label" : `Enter ${contractType} name`;
    let handleClose = () => { };
    const [inputValue, setInputValue] = useState("");
    const [inputError, setInputError] = useState(false);

    if (isCargoOpen) {
      handleClose = () => setCargoShareModelOpen(false);
    } else if (isVesselOpen) {
      handleClose = () => setVesselShareModelOpen(false);
    } else if (isEstimateOpen) {
      handleClose = () => setEstimateShareModelOpen(false);
    }

    const handleShare = () => {
      const name = inputValue.trim();
      if (!name) {
        setInputError(true);
        return;
      }
      if (mainTab === 0) {
        if (isCargoOpen) {
          createCargoContract({
            ...selectedContractForShare.data,
            contractName: name,
            access: "public",
          })
            .then(() => {
              setCargoShareModelOpen(false);
              fetchCargoContracts();
              setSelectedContractForShare("");
              toastSuccess("Cargo Contract shared with Team Successfully");
            })
            .catch((err) => {
              toastError("Error while sharing Cargo Contract");
            });
        } else if (isVesselOpen) {
          createVesselContract({
            ...selectedContractForShare.data,
            contractName: name,
            access: "public",
          })
            .then(() => {
              setVesselShareModelOpen(false);
              fetchVesselContracts();
              setSelectedContractForShare("");
              toastSuccess("Vessel Contract shared with Team Successfully");
            })
            .catch((err) => {
              toastError("Error while sharing Vessel Contract");
            });
        } else if (isEstimateOpen) {
          createEstimateContract({
            ...selectedContractForShare.data,
            estimateLabel: name,
            access: "public",
          })
            .then(() => {
              setCargoShareModelOpen(false);
              fetchCargoContracts();
              setSelectedContractForShare("");
              toastSuccess("Estimate Contract shared with Team Successfully");
            })
            .catch((err) => {
              toastError("Error while sharing Estimate Contract");
            });
        }
        handleClose();
      } else if (mainTab === 1) {
        if (isCargoOpen) {
          const { _id, createdAt, updatedAt, estId, ...restData } = selectedContractForShare.data;
          createCargoContract({
            ...restData,
            contractName: name,
            status: "open",
          })
            .then(() => {
              setCargoShareModelOpen(false);
              fetchCargoContracts();
              setSelectedContractForShare("");
              toastSuccess("Contract Copied Successfully");
            })
            .catch((err) => {
              toastError("Error while Copying Cargo Contract");
            });
        } else if (isVesselOpen) {
          const { _id, createdAt, updatedAt, estId, ...restData } = selectedContractForShare.data;
          createVesselContract({
            ...restData,
            status: "open",
            contractName: name,
          })
            .then(() => {
              setVesselShareModelOpen(false);
              fetchVesselContracts();
              setSelectedContractForShare("");
              toastSuccess("Contract Copied Successfully");
            })
            .catch((err) => {
              toastError("Error while Copying Vessel Contract");
            });
        } else if (isEstimateOpen) {
          const { _id, createdAt, updatedAt, estId, ...restData } = selectedContractForShare.data;
          createEstimateContract({
            ...restData,
            status: "open",
            contractName: name,
          })
            .then(() => {
              setCargoShareModelOpen(false);
              fetchCargoContracts();
              setSelectedContractForShare("");
              toastSuccess("Contract Copied Successfully");
            })
            .catch((err) => {
              toastError("Error while Copying Estimate Contract");
            });
        }
        handleClose();
      }
    };

    return (
      <CustomAddModal
        open={modalOpen}
        title={title}
        maxWidth="xs"
        saveLabel={isCopy ? "Copy" : "Share"}
        handleClose={handleClose}
        onSubmitConfirm={handleShare}
        contentPaddingClass="!px-4 !py-2"
      >
        <SaveCargoLabel
          placeholder={placeholder}
          value={inputValue}
          onChange={(e) => {
            setInputValue(e.target.value);
            setInputError(false);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleShare();
          }}
          label={label}
          guidanceTitle={isCopy ? `Copy this ${contractType}` : `Share this ${contractType}`}
          guidance={guidance}
          error={inputError ? `Enter ${label.toLowerCase()} to ${isCopy ? "copy" : "share"}.` : ""}
        />
      </CustomAddModal>
    );
  };
  const onChangePinQuery = (queryDetails) => {
    const queryId = queryDetails._id;
    const isFindIndex = cargoAnalysisData.findIndex((item) => item === queryId);
    let updatedQueryList = [...cargoAnalysisData];
    if (isFindIndex > -1) {
      updatedQueryList.splice(isFindIndex, 1);
    } else {
      updatedQueryList.push(queryId);
    }
  };

  const handleDateRangeChange = async (newDateRange) => {
    const { startDate, endDate } = newDateRange;
    const formattedStartDate = startDate?.toISOString() || "";
    const formattedEndDate = endDate?.toISOString() || "";

    try {
      const filterState =
        subTab === "1"
          ? cargoFilters
          : subTab === "2"
            ? vesselFilters
            : estimateFilters;
      const setFilterState =
        subTab === "1"
          ? setCargoFilters
          : subTab === "2"
            ? setVesselFilters
            : setEstimateFilters;

      const filters = {
        ...filterState,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        offset: 1,
      };

      setFilterState(filters);

      switch (subTab) {
        case "1":
          await fetchCargoContracts(filters);
          break;
        case "2":
          await fetchVesselContracts(filters);
          break;
        case "3":
          await fetchEstimateContracts(filters);
          break;
        default:
          break;
      }
    } catch (error) {
      console.error("Date range change error:", error);
    }
  };

  // Debounced search function
  const performSearch = useCallback(
    _.debounce(async (value) => {
      try {
        const filterState =
          subTab === "1"
            ? cargoFilters
            : subTab === "2"
              ? vesselFilters
              : estimateFilters;
        const setFilters =
          subTab === "1"
            ? setCargoFilters
            : subTab === "2"
              ? setVesselFilters
              : setEstimateFilters;

        const filters = {
          ...filterState,
          search: value,
          offset: 1,
        };

        setFilters(filters);

        switch (subTab) {
          case "1":
            await fetchCargoContracts(filters);
            break;
          case "2":
            await fetchVesselContracts(filters);
            break;
          case "3":
            await fetchEstimateContracts(filters);
            break;
          default:
            break;
        }
      } catch (error) {
        console.error("Search error:", error);
      }
    }, 500),
    [subTab, cargoFilters, vesselFilters, estimateFilters]
  );

  const onSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    performSearch(value);
  };

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    // If data for this tab was already fetched, no need to refetch on tab switch
    if (subTab === "1" && hasFetchedCargo) return;
    if (subTab === "2" && hasFetchedVessel) return;
    if (subTab === "3" && hasFetchedEstimate) return;

    setSearchValue("");

    if (subTab === "1") {
      fetchCargoContracts();
    } else if (subTab === "2") {
      fetchVesselContracts();
    } else {
      fetchEstimateContracts();
    }
  }, [subTab]);

  useEffect(() => {
    if (subTab === "1") {
      fetchCargoContracts();
    } else if (subTab === "2") {
      fetchVesselContracts();
    } else {
      fetchEstimateContracts();
    }
  }, [cargoFilters.offset, vesselFilters.offset, estimateFilters.offset]);

  useEffect(() => {
    // On main tab (My/All) change: reset cache flags and fetch all 3 tabs in parallel
    setHasFetchedCargo(false);
    setHasFetchedVessel(false);
    setHasFetchedEstimate(false);
    setEstimateFilters(initialPagination);
    setCargoFilters(initialPagination);
    setVesselFilters(initialPagination);
    setSearchValue("");
    setIsLoadingCargo(true);
    setIsLoadingVessel(true);
    setIsLoadingEstimate(true);
    fetchCargoContracts(initialPagination);
    fetchVesselContracts(initialPagination);
    fetchEstimateContracts(initialPagination);
  }, [mainTab]);

  useEffect(() => {
    if (!organizationId && mainTab === 1) {
      setMainTab(0);
    }
  }, [organizationId, mainTab]);

  const mainTabs = [
    {
      label: "My Contracts",
      key: 0,
      tooltip: "Displays contracts created by you.",
    },
    ...(organizationId
      ? [
        {
          label: "All Contracts",
          key: 1,
          tooltip:
            "Displays contracts shared with your organization. Copy any contract to your personal list.",
        },
      ]
      : []),
  ];

  const subTabs = [
    {
      label: "Cargo Contracts",
      key: "1",
      tooltip:
        mainTab === 1
          ? "Displays cargo contracts shared with your organization."
          : "Displays cargo contracts created by you.",
    },
    {
      label: "Vessel Contracts",
      key: "2",
      tooltip:
        mainTab === 1
          ? "Displays vessel contracts shared with your organization."
          : "Displays vessel contracts created by you.",
    },
    {
      label: "Pre-Fix Estimate",
      key: "3",
      tooltip:
        mainTab === 1
          ? "Displays pre-fix estimate contracts shared with your organization."
          : "Displays pre-fix estimate contracts created by you.",
    },
  ];

  return (
    <Box className="flex flex-col w-full min-h-[calc(100vh-110px)]">
      {/* Main Tabs */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        mb={2}
        className="gap-4 xl:gap-10 flex-wrap max-w-[100%] mx-auto"
      >
        <div className="flex items-center gap-4 xl:gap-10 flex-wrap">
          {/* Main tabs */}
          <CustomTabs
            tabs={mainTabs}
            active={mainTab}
            onChange={handleMainTabChange}
          />

          {/* Sub Tabs */}
          <CustomTabs
            tabs={subTabs}
            active={subTab}
            onChange={handleSubTabChange}
          />
        </div>

        {/* Desktop Search */}
        <div className="desktop-searchbar hidden xl:block flex-1 min-w-[300px]">
          <SearchBar
            onDateRangeChange={handleDateRangeChange}
            placeholder="Search with Operation Name, Operation Type..."
            setSearchValue={onSearchChange}
            searchValue={searchValue}
          />
        </div>

        {/* Mobile Search */}
        <div className="xl:hidden w-full mt-3">
          <SearchBar
            isMobile
            onDateRangeChange={handleDateRangeChange}
            placeholder="Search with Operation Name, Operation Type..."
            setSearchValue={onSearchChange}
            searchValue={searchValue}
          />
        </div>
      </Box>



      {/* Sub Tabs with TabContext */}
      <TabContext value={subTab}>
        {/* Tab Panels */}
        <Box>
          <TabPanel value="1" style={{ padding: 0 }}>
            <div className="min-h-[77vh] w-full">
              {renderCargoContractsTable()}
            </div>
          </TabPanel>
          <TabPanel value="2" style={{ padding: 0 }}>
            <div className="min-h-[77vh] w-full">
              {renderVesselContractsTable()}
            </div>
          </TabPanel>
          <TabPanel value="3" style={{ padding: 0 }}>
            <div className="min-h-[77vh] w-full">
              {renderEstimateTable()}
            </div>
          </TabPanel>
        </Box>
      </TabContext>
      <CustomShowModal
        open={modelOpen}
        title={
          modelType === "vessel-cargo" && subTab === "1"
            ? "Select Vessel"
            : modelType === "vessel-cargo" && subTab === "2"
              ? "Select Cargo"
              : "Create Estimate"
        }
        maxWidth="lg"
        saveLabel={"Create"}
        disableClose={loader}
        handleClose={onCloseSaveCargoVesselModal}
        hideButtons={true}
      >
        <ContractSelectionStepper
          modelType={modelType}
          vesselContractDetails={vesselContractDetails}
          cargoContractDetails={cargoContractDetails}
          handleModalPagination={handleModalPagination}
          modalVesselFilters={modalVesselFilters}
          modalCargoFilters={modalCargoFilters}
          onClickVessel={onClickVessel}
          onClickCargo={onClickCargo}
          selectedVessel={selectedVessel}
          selectedCargo={selectedCargo}
          loader={loader}
          submitting={loader}
          setLoader={setLoader}
          onSubmitConfirm={handleEstimateCreation}
          onCloseSaveCargoVesselModal={onCloseSaveCargoVesselModal}
          currentContract={currentContract}
          subTab={subTab}
        />
      </CustomShowModal>

      <CustomAddModal
        open={isCargoEditing}
        title={"Update Cargo Contract"}
        maxWidth="md"
        saveLabel={"Update"}
        handleClose={handleCloseEditModel}
        addThirdBtn
        thirdBtnAction={() => handleCopyWarningModal("cargo")}
        thirdBtnLabel="Copy Contract"
        onSubmitConfirm={() => handleUpdateWarningModal("cargo")}
      >
        <CreateCargoContractForm
          formData={cargoFormData}
          setFormData={setCargoFormData}
          handleChange={handleCargoContractInputChange}
          removeAttachment={removeCargoAttachment}
          textContract={cargoTextContract}
          handleTextContractUpload={handleCargoTextContractUpload}
          handleAttachmentUpload={handleCargoContractAttachmentUpload}
          attachments={cargoAttachments}
          setTextContract={setCargoTextContract}
          isEditing
          prevAttachments={prevAttachments}
          setPrevAttachments={setPrevAttachments}
        />
      </CustomAddModal>

      <CustomAddModal
        open={isVesselEditing}
        title={"Update Vessel Contract"}
        maxWidth="md"
        saveLabel={"Update"}
        handleClose={handleCloseEditModel}
        onSubmitConfirm={() => handleUpdateWarningModal("vessel")}
        addThirdBtn
        thirdBtnAction={() => handleCopyWarningModal("vessel")}
        thirdBtnLabel="Copy Contract"
      >
        <VesselContractForm
          formData={vesselFormData}
          setFormData={setVesselFormData}
          handleChange={handleVesselContractInputChange}
          attachments={vesselAttachments}
          textContract={vesselTextContract}
          removeAttachment={removeVesselAttachment}
          handleTextContractUpload={handleVesselTextContractUpload}
          handleAttachmentUpload={handleVesselContractAttachmentUpload}
          isEditing
          setTextContract={setVesselTextContract}
          prevAttachments={prevAttachments}
          setPrevAttachments={setPrevAttachments}
        />
      </CustomAddModal>

      <CustomAddModal
        open={isVesselViewModelOpen}
        title={"View Vessel Details"}
        maxWidth="lg"
        handleClose={() => setIsVesselViewModelOpen(false)}
        onSubmitConfirm={() => handleUpdateVesselDetails()}
        saveLabel={"Update Vessel"}
      >
        <VesselViewModel
          ref={vesselRef}
          currentContract={currentContract}
          setCurrentContract={setCurrentContract}
          handleClose={() => setIsVesselViewModelOpen(false)}
          refetch={() => fetchVesselContracts(vesselFilters, false)}
          isOps={false}
        />
      </CustomAddModal>

      <CustomShowModal
        open={cargoAnalysisStepper}
        title={"Cargo Analysis"}
        maxWidth="lg"
        saveLabel={"Create"}
        handleClose={() => setCargoAnalysisStepper(false)}
      >
        <CreateCargoAnalysis
          // ref={addQueryModalRef}
          setLoader={setLoader}
          analysisVessel={analysisVessel}
          cargoAnalysisData={cargoAnalysisData}
          setCargoAnalysisData={setCargoAnalysisData}
          onCloseModal={() => setCargoAnalysisStepper(false)}
          selectedQuery={cargoAnalysisData}
          selectedPorts={selectedPorts}
          onChangePinQuery={onChangePinQuery}
          isOtherTab
        />
      </CustomShowModal>

      <CustomAddModal
        open={isCargoViewModelOpen}
        title={"Update Cargo"}
        maxWidth="lg"
        saveLabel={"Update"}
        onSubmitConfirm={handleUpdateCargo}
        handleClose={() => setIsCargoViewModelOpen(false)}
      >
        <CargoViewModel
          ref={addQueryModalRef}
          setLoader={setLoader}
          cargoAnalysisData={currentContract}
          setCargoAnalysisData={setCargoAnalysisData}
          onCloseModal={() => setIsCargoViewModelOpen(false)}
          selectedQuery={currentContract}
          selectedPorts={selectedPorts}
          onChangePinQuery={onChangePinQuery}
          isOtherTab
          refetch={() => fetchCargoContracts(cargoFilters, false)}
        />
      </CustomAddModal>

      <CustomShowModal
        open={isShareToOperationModelOpen}
        title={"Share to Operation"}
        maxWidth="md"
        saveLabel={"Update"}
        handleClose={() => setIsShareToOperationModelOpen(false)}
      >
        <ShareToOperationModel
          selectedContractId={currentContract}
          currentUserId={currentUserId}
          handleClose={() => setIsShareToOperationModelOpen(false)}
          refetch={() => fetchEstimateContracts(estimateFilters, false)}
        />
      </CustomShowModal>

      <DeleteConfirmationModal />
      <ShareModal />

      <EstimateCreateConfirmationModal
        isOpen={estimateCreateConfirmationOpen}
        onClose={closeEstimateModal}
        onConfirm={confirmEstimateCreation}
        contractType={estimateData?.contractType}
      />

      <CustomConfirmModal
        open={copyWarningModal.isOpen}
        handleClose={() =>
          setIsCopyWarningModalOpen({
            isOpen: false,
            type: "",
          })
        }
        message="Are you sure you want to create a copy of this contract?"
        onSubmitConfirm={() => {
          handleCopyContract();
          setIsCopyWarningModalOpen({
            isOpen: false,
            type: "",
          });
        }}
        type="warning"
        confirmText="Confirm"
        cancelText="Cancel"
        note="This action will add a new copy of this contract to your contracts list."
      />

      <CustomConfirmModal
        open={updateWarningModal.isOpen}
        handleClose={() =>
          setIsUpdateWarningModalOpen({
            isOpen: false,
            type: "",
          })
        }
        message="Are you sure you want to update this contract?"
        onSubmitConfirm={() => {
          if (updateWarningModal.type === "cargo") {
            handleUpdateCargoContract();
          } else if (updateWarningModal.type === "vessel") {
            handleUpdateVesselContract();
          }
          setIsUpdateWarningModalOpen({
            isOpen: false,
            type: "",
          });
        }}
        type="warning"
        confirmText="Update"
        cancelText="Cancel"
        note="Please double check all the details before submitting the update."
      />

      <CustomConfirmModal
        open={showClosedContract.isOpen}
        handleClose={() =>
          setShowClosedContract({
            isOpen: false,
            id: "",
          })
        }
        message="Are you sure you want to update this closed contract?"
        onSubmitConfirm={() => {
          window.open(
            `/saved-revised-contracts/${showClosedContract.id}`,
            "_blank"
          );
          setShowClosedContract({
            isOpen: false,
            id: "",
          });
        }}
        type="warning"
        confirmText="Update"
        cancelText="Cancel"
        note="Any updates made here will automatically reflect in the Operations module and impact its calculations"
      />
    </Box>
  );
};

export default Contracts;
